export default "__VITE_ASSET__DzMGi$Tx__"